module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v("目前最低存量: " + _vm._s(_vm.amount))]), _c('br'), _c('span', [_vm._v("請輸入欲重新設定之最低存量")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "click": _vm.useNumPad,
      "keydown": _vm.useNumPad,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("確定")]), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])]), _c('NumberInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPad),
      expression: "showPad"
    }],
    attrs: {
      "defaultNumber": _vm.number
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bc0c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/ResetLowAmountLimit.vue
// module id = 1361
// module chunks = 1